import React from 'react'

import PropTypes from 'prop-types'

import { isStandaloneMode } from '../../utils/modeHelper'
import FullScreenButton from '../FullScreenButton'

import LanguageToggle from './LanguageToggle'
import MarkDoneButton from './MarkDoneButton'
import {
  Brand,
  BrandLogo,
  FullScreenButtonContainer,
  MarkDoneButtonContainer,
  Wrapper,
} from './style'
import Title from './Title'

const TitleBarComponent = () => {
  const standaloneMode = isStandaloneMode()

  return (
    <Wrapper>
      <Brand>
        <BrandLogo aria-hidden="true" focusable="false" viewBox="0 0 27 32">
          <path
            clipRule="evenodd"
            d="M21.4452 7.56228C18.849 8.38416 11.7821 8.24442 6.98503 12.397C2.81772 16.0045 4.67108 19.8969 12.7685 18.3543C14.0308 18.1134 14.1475 19.0309 13.3275 19.531C-3.46774 27.8703 -6.97498 5.15731 18.0262 0.166276C21.6401 -0.555397 22.8352 1.1803 23.5366 3.16053C24.2381 5.14077 24.0423 6.7404 21.4461 7.56228H21.4452Z"
            fill="currentColor"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M5.20457 24.3952C7.81915 23.6322 14.8805 23.9309 19.7695 19.8886C24.0168 16.3768 22.2526 12.443 14.1221 13.8027C12.8543 14.0151 12.7587 13.0948 13.5898 12.614C30.5698 4.65537 33.5622 27.4428 8.45532 31.8666C4.82581 32.5064 3.67021 30.7441 3.01381 28.7491C2.35741 26.7542 2.58908 25.1592 5.20366 24.3952H5.20457Z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </BrandLogo>
      </Brand>
      <Title />
      <LanguageToggle />
      {!standaloneMode && (
        <MarkDoneButtonContainer>
          <MarkDoneButton />
        </MarkDoneButtonContainer>
      )}
      <FullScreenButtonContainer>
        <FullScreenButton />
      </FullScreenButtonContainer>
    </Wrapper>
  )
}

TitleBarComponent.propTypes = {
  close: PropTypes.func,
}

export default TitleBarComponent
